import React from 'react';
import { useParams, Link } from 'react-router-dom';
import style from './index.module.css';
import MyFooter from '../../components/MyFooter';
import { detailedEventList } from '../../assets/constants';
import { getImage, getIcon } from '../../utils/utils';
import { useTheme } from '@mui/material/styles';
import { motion } from 'framer-motion';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import Button from '@mui/material/Button';

const ServiceDetail = () => {
    const { serviceId } = useParams();
    const theme = useTheme();
    const isDark = theme.palette.mode === 'dark';
    
    const service = detailedEventList.find(s => s.id === serviceId);

    if (!service) {
        return (
            <div className={style.notFound}>
                <h1>Service Not Found</h1>
                <Link to="/our_services">Back to Services</Link>
            </div>
        );
    }

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            style={{
                width: '100%',
                minHeight: '100vh',
                backgroundColor: theme.palette.background.default,
                color: theme.palette.text.primary,
            }}
        >
            <div className={style.hero} style={{ backgroundImage: `url(${getImage(service.image)})` }}>
                <div className={style.heroOverlay}>
                    <motion.div 
                        initial={{ y: 30, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        className={style.heroContent}
                    >
                        <Link to="/our_services" className={style.backLink}>
                            <ArrowBackIcon /> Back to Services
                        </Link>
                        <h1>{service.header}</h1>
                    </motion.div>
                </div>
            </div>

            <div className={style.container}>
                <div className={style.contentGrid}>
                    <motion.div 
                        initial={{ x: -50, opacity: 0 }}
                        whileInView={{ x: 0, opacity: 1 }}
                        viewport={{ once: true }}
                        className={style.mainInfo}
                    >
                        <div className={style.iconHeader}>
                            {getIcon(service.icon)}
                            <h2>Service Overview</h2>
                        </div>
                        <p className={style.description}>{service.content}</p>
                        
                        <div className={style.actionBox}>
                            <h3>Interested in this service?</h3>
                            <p>Contact us today for a free consultation and custom quote.</p>
                            <Button 
                                component={Link} 
                                to="/contact" 
                                variant="contained" 
                                size="large"
                                sx={{ borderRadius: 10, px: 4 }}
                            >
                                Get a Quote
                            </Button>
                        </div>
                    </motion.div>

                    <motion.div 
                        initial={{ x: 50, opacity: 0 }}
                        whileInView={{ x: 0, opacity: 1 }}
                        viewport={{ once: true }}
                        className={style.featuresList}
                    >
                        <h2>What's Included</h2>
                        <ul>
                            {service.features.map((feature, index) => (
                                <motion.li 
                                    key={index}
                                    initial={{ opacity: 0, x: 20 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ delay: index * 0.1 }}
                                    viewport={{ once: true }}
                                >
                                    <CheckCircleOutlineIcon sx={{ color: theme.palette.primary.main, mr: 2 }} />
                                    {feature}
                                </motion.li>
                            ))}
                        </ul>
                    </motion.div>
                </div>
            </div>

            <MyFooter />
        </motion.div>
    );
};

export default ServiceDetail;
